export default {"src":"/_next/static/media/location-summary.921c7950.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};